<template>
	<div class="innerBox">
		<h2 class="mb-4">Absensi</h2>

		<panel class="border border-secondary mb-4" :noExpand="true">
			<template slot="header">
				<h4 class="panel-title">Filter</h4>
			</template>
			<div class="row outerBox filterBox">
				<div class="col row">
					<div class="col-md-4 col-6">
						<label>Tanggal :</label>
						<flat-pickr
							v-model="date"
							:config="rangeConfig"
							placeholder="Pilih Tanggal"
						></flat-pickr>
					</div>
					<div class="col-md-3 offset-md-5" style="display: flex; flex-direction: column-reverse" :class="mobile ? 'pt-20' : ''">
						<button type="button" class="btn btn-primary" style="height:42px; margin-bottom:0.5%" @click="getListOfLabourer()">Filter</button>
					</div>
				</div>
			</div>
		</panel>

		<div class="row row-space" v-if="attendanceList">
			<div class="offset-md-10 offset-4 col-md-2 col-6 mb-4">
				<button
					class="btn btn-success w-100"
					@click="showUploadModal = true"
				>
					Input Absensi
				</button>
			</div>

			
			<div class="col-12" style="display:block;overflow-x:scroll">
				<h4>Status Absensi Pada Hari {{date.split(" ")[0]}}</h4>
				<table class="table text-center border border-secondary" v-if="labourerList && attendanceList">
					<thead class="thead-dark">
						<th>Nama Pegawai</th>
						<th>Jam Masuk</th>
						<th>Jam Pulang</th>
						<th>Status Absensi</th>
						<th colspan="3"><i class="fa fa-cog"></i></th>
					</thead>
					<tbody>
						<tr v-for="labourer in labourerList" :key="labourer.id">
							<td>{{labourer.name}}</td>
							<td>{{labourer.attendance && labourer.attendance.clock_in ? new moment(labourer.attendance.clock_in).format("hh:mm A") : '-'}}</td>
							<td>{{labourer.attendance && labourer.attendance.clock_out ? new moment(labourer.attendance.clock_out).format("hh:mm A") : '-'}}</td>
							<td>{{labourer.attendance && labourer.attendance.is_waiver ? `Terizin ( ${labourer.attendance.description} )`  : '-'}}</td>
							<td>
								<div  v-if="!labourer.attendance || (labourer.attendance && !labourer.attendance.clock_in)">
									<button :disabled="moment().date() != new moment(start).date() " class="attendancebtn btn btn-primary w-75" @click="insertAttendance(0, labourer.id , 'clock_in')">Masuk</button>
								</div>
								<div v-else-if="labourer.attendance && labourer.attendance.clock_in">
									<button :disabled="moment().date() != new moment(start).date() || labourer.attendance.clock_out" class="attendancebtn btn btn-danger w-75" @click="insertAttendance(labourer.attendance.id , labourer.id , 'clock_out')">Keluar</button>
								</div>
							</td>
							<td >
								<button :disabled="labourer.attendance" @click="showWaiverModal = true;labourer_id = labourer.id" class="btn btn-warning w-75">Izin</button>
							</td>
							<td>
								<button class="attendancebtn btn btn-info w-75" @click="showDetailModal = true;labourer_id = labourer.id;labourer_name = labourer.name">Liat Detail</button>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>

		<waiverModal 
			v-if="showWaiverModal"
			@closeModal="showWaiverModal = false"
			@updateTable="getListOfLabourer"
			:labourer_id="labourer_id"
		/>

		<detailAttendanceModal 
			v-if="showDetailModal"
			@closeModal="showDetailModal = false"
			@updateTable="getListOfLabourer"
			:labourer_id="labourer_id"
			:labourer_name="labourer_name"
		/>

		<excelUploadModal 
			v-if="showUploadModal"
			@closeModal="showUploadModal = false"
			@updateTable="getListOfLabourer"
		/>

	</div>
</template>

<script>
import moment from 'moment'
import waiverModal from './children/waiverModal'
import detailAttendanceModal from './children/detailAttendanceModal'
import excelUploadModal from './children/uploadDocument'

export default {
	data () {
		let start = new moment().format('Y-MM-DD') + ' 00:00:00'
		let end = new moment().format('Y-MM-DD') + ' 23:59:59'
		return {
			labourer_id : null,
			labourer_name : null,
			showWaiverModal : false,
			showDetailModal : false,
			showUploadModal : false,
			attendanceList : null,
			labourerList : null,
			moment,
			mobile : this.isMobile(),
			start : start,
			end : end,
			date : `${start}`,
			rangeConfig: {
				altInput: true,
				altInputClass: 'form-control input flatpickr-input w-100',
				animate: !this.isRTL()
			},
		}
	},
	watch : {

	},
	components : {
		waiverModal,
		detailAttendanceModal,
		excelUploadModal
	},
	mounted () {
		this.getListOfLabourer()
	},
	methods : {
		insertAttendance (id , labourer_id , type) {
			let data = {
				labourer_id : labourer_id,
			}

			data.id = id
			data[type] = true

			this.$http.post('/api/v1/attendance' , data)
			.then((resp) => {
				this.$store.dispatch('triggerAlert' , [true , 'Absensi Berhasil Tercatat'])
				this.loadAttendance()
			})
			.catch((err) => {
				console.log(err)
			})
		},
		getListOfLabourer () {
			this.labourerList = null
			this.data = null

			this.$http.get('/api/v1/masterData/labourer?pagination=false')
			.then((resp) => {
				this.labourerList = resp.data.data
				this.loadAttendance()
			})
			.catch((err) => {
				console.log(err)
			})
		},
		loadAttendance () {
			this.start = new moment(new Date(this.date)).format('Y-MM-DD') + ' 00:00:00'
			this.end = new moment(new Date(this.date)).format('Y-MM-DD') + ' 23:59:59'

			let url = `/api/v1/attendance?start=${this.start}&end=${this.end}&pagination=false`
			this.$http.get(url)
			.then((resp) => {
				let list = resp.data.data

				for(var i = 0 ; i < list.length ; i++) {
					let attendance  = list[i]
					// console.log(attendance)

					let selectedLabour = this.labourerList.find(x => x.id == attendance.labourer_id)

					if(!selectedLabour) continue

					selectedLabour.attendance =  attendance
				}

				this.attendanceList = list


			})
			.catch((err) => {
				console.log(err)
			})
		},
		// addSampleData () {
		// 	let url = '/api/v1/attendance'

		// 	let data = {
		// 		"labourer_id": 3,
		// 		"in": true,
		// 		is_waiver : false,
		// 		"description": "a"
		// 	}

		// 	this.$http.post(url , data)
		// 	.then((resp) => {
		// 		this.$store.dispatch('triggerAlert' , [true , 'Absensi Berhasil Di Simpan'])
		// 		this.loadAttendance()
		// 	})
		// 	.catch((err) => {
		// 		console.log(err)
		// 	})
		// }
	}
}
</script>

<style scoped>
	td {
		vertical-align: middle;
	}
</style>